// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"79f8698b","598":"702ac3d6","684":"d621c74c","703":"460952bc"}[chunkId] + ".chunk.js";
};